import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type SettingState } from '../types';

const loadSettingsCase: CaseReducer<
  SettingState,
  PayloadAction<SettingState>
> = (_, action) => {
  return action.payload;
};

export { loadSettingsCase };
